<script>
import axios, { AxiosResponse } from 'axios';
import Vue from 'vue';

export default class RequestService extends Vue {
  // returns true if has read write access, not mulesoft specific
  static checkCredentials() {
    const userPermission = axios.get('/api/mulesoftcore/checkCredentials');

    return userPermission;
  }
}
</script>
